/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CarrierStatus = {
    Registration: 'REGISTRATION',
    WaitingForReview: 'WAITING_FOR_REVIEW',
    OnReview: 'ON_REVIEW',
    Registered: 'REGISTERED',
    Rejected: 'REJECTED',
    Suspended: 'SUSPENDED'
} as const;
export type CarrierStatus = typeof CarrierStatus[keyof typeof CarrierStatus];

